import { useEffect } from 'react';
import type { Route, Component } from './app-routes-revamp';

type RouteParam = Route & {
  component?: Component;
};

export function usePreload(routes: RouteParam[]) {
  useEffect(() => {
    routes.forEach((route) => {
      const {
        Content,
        LeftSidebar,
        RightSidebar,
        Header,
        Skyline,
        Footer,
        component
      } = route;

      [
        Content,
        LeftSidebar,
        RightSidebar,
        Header,
        Skyline,
        Footer,
        component
      ].forEach((Component) => {
        if (Component && typeof Component.preload === 'function') {
          Component.preload();
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
